import { faLock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { tv } from "tailwind-variants";

const styles = tv({
  base: "group flex min-w-[100px] flex-col",
});

interface IProps {
  to: string;
  external: boolean;
  newTab: boolean;
  isLocked: boolean;
  children: ReactNode;
  onClick: (menu: IOpenMenuType) => void;
}

const MobileNavLink = ({
  to,
  external,
  newTab,
  isLocked,
  children,
  onClick,
}: IProps) => {
  const closeMenuOnClick = () => onClick("NONE");

  const renderLockedIcon = () =>
    isLocked && <FontAwesomeIcon fixedWidth icon={faLock} className="ml-10" />;

  if (external) {
    return (
      <a
        href={to}
        className={styles()}
        target={newTab ? "_blank" : "_self"}
        onClick={closeMenuOnClick}>
        {children}
        {renderLockedIcon()}
      </a>
    );
  }

  return (
    <Link to={to} className={styles()} onClick={closeMenuOnClick}>
      {children}
      {renderLockedIcon()}
    </Link>
  );
};

export default MobileNavLink;
